import { Tooltip } from '@mui/material';

import { Iconify } from './iconify';

export const TooltipInfo = ({ title }: { title: string }) => (
  <Tooltip title={title} sx={{ ml: 0.5, cursor: 'help' }} arrow>
    <Iconify
      icon="eva:info-outline"
      width={16}
      sx={{ ml: 0.5, cursor: 'help' }}
      color="text.secondary"
    />
  </Tooltip>
);
